import { render } from "./coacheRegistration.vue?vue&type=template&id=ed2e86f6"
import script from "./coacheRegistration.vue?vue&type=script&lang=js"
export * from "./coacheRegistration.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__